/**
 * @file: 号码认证申诉接口
 * @author: wence
 */

import {
    POST_NUMBER_REPORT,
    GET_ALREADY_PHONE_LIST,
    GET_INSTANCE_INFO
} from '../actions/ActionTypes';

export function postNumberReport(state = {}, action) {
    switch (action.type) {
        case POST_NUMBER_REPORT:
            return action.data;
        default:
            return state;
    }
}

export function phoneList(state = {}, action) {
    switch (action.type) {
        case GET_ALREADY_PHONE_LIST:
            return action.data;
        default:
            return state;
    }
}

export function instanceInfo(state = {}, action) {
    switch (action.type) {
        case GET_INSTANCE_INFO:
            return action.data;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/numberOptions.js